//Config file in public folder and also included in index.html file
export const endpoint = process.env.NODE_ENV === 'production' ? window.config.endpoint_prod:window.config.endpoint_dev;
